import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export const TabWrapperStyle = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
`;

const TabsStyle = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(10px, max-content));
	font-weight: 500;
`;

const TabStyle = styled.div`
	padding: 8px 25px;
	border: 1px solid #e6e6e6;
	border-bottom: 0;
	text-transform: uppercase;
	font-size: 10px;
	color: #a1a1a1;
	letter-spacing: 0.5px;
	position: relative;
	cursor: pointer;
	user-select: none;

	&:hover {
		color: #6e0fea;
	}

	&.selected {
		color: #6e0fea;
		&::after {
			content: '';
			display: block;
			width: 100%;
			height: 1px;
			background: white;
			position: absolute;
			left: 0;
			bottom: -1px;
		}
	}
`;

export const Tabs = ({children}) => {
	const [selectedTab, setSelectedTab] = useState(0);
	const [selectedTabContent, setSelectedTabContent] = useState(null);
	useEffect(() => {
		let defaultSelectedTab = 0;
		React.Children.forEach(children, (child, index) => {
			if (!child) return;
			if (child.props.defaultSelected) {
				defaultSelectedTab = index;
			}
		});
		setSelectedTab(defaultSelectedTab);
	}, []);

	const setTabContent = () => {
		let foundTab = null;
		React.Children.forEach(children, (child, index) => {
			if (!child) return;
			if (index === selectedTab) {
				foundTab = child;
			}
		});
		setSelectedTabContent(foundTab);
	};

	useEffect(() => {
		React.Children.forEach(children, (child, index) => {
			if (!child) return;
			if (child.props.isSelected) {
				setSelectedTab(index);
				return;
			}
		});
		setTabContent();
	}, [children]);

	useEffect(() => {
		setTabContent();
	}, [selectedTab]);

	return (
		<TabWrapperStyle>
			<TabsStyle>
				{React.Children.map(children, (child, index) => {
					if (!child) return null;
					return (
						<TabStyle
							key={index}
							className={selectedTab === index ? ' selected' : ''}
							onClick={() => setSelectedTab(index)}
							data-cy={child.props.cy ? child.props.cy : undefined}
						>
							{child.props.title}
						</TabStyle>
					);
				})}
			</TabsStyle>
			{selectedTabContent}
		</TabWrapperStyle>
	);
};

Tabs.propTypes = {
	/**
	 * Tabs can only contain Tab elements
	 */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
